<app-modal-generico [modelo]="modalGenerico">
  <ul class="list-group">
    <div
      class="form-group"
      *ngIf="tipo_prestador_guia !== authService.getRolDetalleUser()"
    >
      <li
        class="list-group-item pointer"
        (click)="selecionarDato(tipo_rnt_esblecimiento)"
      >
        <img
          src="../../../../../../../../assets/icons/checked_2.png"
          alt=""
          height="18"
          *ngIf="seleccionado !== tipo_rnt_esblecimiento"
        />
        <img
          src="../../../../../../../../assets/icons/checked.png"
          alt=""
          height="18"
          *ngIf="seleccionado === tipo_rnt_esblecimiento"
        />
        <label for="establecimiento" class="ml-4 form-check-label"
          >Establecimiento de comercio</label
        >
        <input
          id="establecimiento"
          class="form-check"
          type="checkbox"
          [hidden]="true"
        />
      </li>
    </div>

    <div class="form-group" *ngIf="verificacionGuia">
      <li
        class="list-group-item pointer"
        (click)="selecionarDato(tipo_rnt_guia)"
      >
        <img
          src="../../../../../../../../assets/icons/checked_2.png"
          alt=""
          height="18"
          *ngIf="seleccionado !== tipo_rnt_guia"
        />
        <img
          src="../../../../../../../../assets/icons/checked.png"
          alt=""
          height="18"
          *ngIf="seleccionado === tipo_rnt_guia"
        />
        <label for="guia_turismo" class="ml-4 form-check-label"
          >Guía de turismo</label
        >
        <input
          id="guia_turismo"
          class="form-check"
          type="checkbox"
          [hidden]="true"
        />
      </li>
    </div>

    <div class="form-group">
      <li
        class="list-group-item pointer"
        (click)="selecionarDato(tipo_rnt_inmueble)"
      >
        <img
          src="../../../../../../../../assets/icons/checked_2.png"
          alt=""
          height="18"
          *ngIf="seleccionado !== tipo_rnt_inmueble"
        />
        <img
          src="../../../../../../../../assets/icons/checked.png"
          alt=""
          height="18"
          *ngIf="seleccionado === tipo_rnt_inmueble"
        />
        <label for="inmueble" class="ml-4 form-check-label">Inmueble</label>
        <input
          id="inmueble"
          type="checkbox"
          class="form-check"
          [hidden]="true"
        />
      </li>
    </div>
    <div class="form-group" *ngIf="show_tipo_plataforma">
      <li
        class="list-group-item pointer"
        (click)="selecionarDato(tipo_rnt_plataforma)"
      >
        <img
          src="../../../../../../../../assets/icons/checked_2.png"
          alt=""
          height="18"
          *ngIf="seleccionado !== tipo_rnt_plataforma"
        />
        <img
          src="../../../../../../../../assets/icons/checked.png"
          alt=""
          height="18"
          *ngIf="seleccionado === tipo_rnt_plataforma"
        />
        <label for="plataformadigital" class="ml-4 form-check-label">Plataforma Electrónica o Digital</label>
        <input
          id="plataformadigital"
          type="checkbox"
          class="form-check"
          [hidden]="true"
        />
      </li>
    </div>
  </ul>
  <footer class="text-right p-1">
    <button
      class="btn btn-outline-primary modal-tipo-rnt-btn-inicio-outline mr-5 border-0"
      (click)="dismiss()"
    >
      Cancelar
    </button>
    <button
      class="btn btn-primary modal-tipo-rnt-btn-inicio"
      (click)="confirm()"
      [disabled]="!seleccionado"
    >
      Aceptar
    </button>
  </footer>
</app-modal-generico>
